import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'features/store/store';

type NavigationState = {
  // TODO: strongly typed routes one day ^^
  route: string | null;
};

const initialState: NavigationState = {
  route: null,
};

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    navigateTo: (state, action: PayloadAction<string | null>) => {
      state.route = action.payload;
    },
  },
});

export const { navigateTo } = navigationSlice.actions;
export const navigationReducer = navigationSlice.reducer;
export const selectRoute = (state: RootState) => state.navigation.route;
